<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Mutton Bustin' Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center my-4">{{ currentYear }} ELIZABETH STAMPEDE RODEO MUTTON BUSTIN' APPLICATION</div>
        <div v-if="saved">
          <div class="subheading mx-4">
            <p>Your Application has been entered.  Rodeo tickets are required for all entries, as well as family and
              friends accompanying them. They must be shown at sign in. Rodeo tickets are available at <a href="https://www.https://elizabethstampede.com/">www.https://elizabethstampede.com/</a>. A birth certificate copy for
              the participant will be required at sign in. Cameras with detachable lenses are prohibited.</p>

              <p class="headline text-xs-center mt-4"><span class="red--text">ONLY ONE APPLICATION PER CHILD!</span></p>
          </div>
        </div>
        <div v-else>
          <div class="subheading mx-4">
            <p class="title text-xs-center mt-4">Lottery Entries are now open, and it is time to get your kiddo entered! The lottery will run from March 1st - March 15th.</p>

            <v-layout row wrap pb-4>
              <v-flex xs12 md6>
                <b>THE DRAW: EXHIBITION ONLY</b>
                <ul>
                  <li>A random draw of thirty two (32) participants divided among 4 performances.</li>
                  <li>Applications accepted from March 1st - March 15th, 2024.</li>
                  <li>Duplicates will be removed before the draw.</li>
                  <li>An entry fee of $35 due at the time of notification.</li>
                  <li>We do not accept walk-ups, faxes, or mailed applications.</li>
                  <li>NO Refunds for draw-outs will be given.</li>
                </ul>
              </v-flex>

              <v-flex xs12 md6>
                <b>Contestant Rules:</b>
                <ul>
                  <li>Only one entry per child. Duplicates will be deleted before the draw.</li>
                  <li><b>Age:</b> 4 to 7 years of age at time of the rodeo, proof of age required at sign in.</li>
                  <li><b>Weight:</b> 55 pounds or less.</li>
                  <li><b>Dress Code:</b> Western attire is required. i.e. boots, long pants, long sleeve shirt, but NO SPURS.
                    Helmet and vest are supplied by the Elizabeth Stampede and must be worn at the time of the actual ride.</li>
                  <li>Cameras with attachable/professional lenses are prohibited.</li>
                  <li>Prizes will be given to all participants at each performance.</li>
                  <li> <span class="red--text">Wool Riding will happen rain or shine.</span></li>
                </ul>
              </v-flex>
            </v-layout>

            <p class="title text-xs-center mt-4"><b>Check In:</b><br />
              Bring your signed waiver, tickets, and contestant to the Elizabeth Stampede Volunteer booth in Vendor Ally to check in 1 hour before the start of the performance.
            </p>

            <!-- <v-layout pb-4>
              <v-flex xs12 md6 offset-md3>
                <b>Performances:</b>
                <ul>
                  <li>Friday, June 2, 4:00 PM, Friday Night Chute Out, $40 Entry Fee</li>
                  <li>Saturday, June 3, 1:00 PM, PRCA Rodeo, $40 Entry Fee</li>
                  <li>Saturday, June 3, 7:00 PM, PRCA Rodeo, $40 Entry Fee</li>
                  <li>Sunday, June 4,  1:00 PM, PRCA Rodeo, $40 Entry Fee</li>
                </ul>
              </v-flex>
            </v-layout> -->
          </div>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Rider Name"
                    ref="focusName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        label="ST"
                        mask="AA"
                        :rules="[v => !!v || 'State is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Zipcode"
                        mask="#####"
                        :rules="[v => !!v || 'Zip is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.cellPhone"
                    label="Primary"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.homePhone"
                    label="Alternate"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.age"
                    label="Age"
                    mask="#"
                    :rules="[v => !!v || 'Age is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.weight"
                    label="Weight"
                    mask="##"
                    :rules="[v => !!v || 'Weight is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md4>
                  <v-text-field
                    v-model="editedItem.birthDate"
                    label="Birthdate"
                    mask="##/##/####"
                    return-masked-value
                    prepend-icon="cake"
                    :rules="[v => !!v || 'Birthdate is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.parents"
                    label="Parent or Legal Guardian"
                    :rules="[v => !!v || 'Parent or Legal Guardian is required']"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

            <div class="headline text-xs-center mb-4">
              {{ currentYear }} ELIZABETH STAMPEDE MUTTON BUSTIN'<br />
              COMPLETE PARTICIPANTS RELEASE
            </div>

            <div class="subheading mx-4">
              <p>The undersigned, being over the age of majority, understands and acknowledges that rodeo events are dangerous activities and that
                participation in any rodeo event, as either a contestant, employee, volunteer or other participant, exposes the participant to a
                substantial and serious risk of personal injury, death or property damage, especially for children. The undersigned also understands
                and acknowledges that the animals used in rodeo events of Elizabeth Stampede have unpredictable behavior and also that the
                animals behavior may be unknown, as is the participant's ability to control the animal. The undersigned expressly acknowledges that
                participation or his child's participation in any rodeo event will involve such hazards.</p>

                <p>Mindful of these facts, the undersigned, intending to be legally bound hereby, and in consideration of being allowed to participate,
                  or being allowed to have a child participate, in the {{ currentYear }} Elizabeth Stampede, agents,
                  affiliates and sponsors, from any liability under any and all causes, known or unknown, by reason of any injury, loss, damage,
                  death or otherwise, which may be suffered by the undersigned or his child or children, and hereby assumes and accepts, on behalf of
                  himself and/or his child or children, the risk and dangers of injury, pain, suffering, damage, death or other loss which may occur
                  through or by reason of any matter, thing, condition, negligence or default.</p>

                <p>The undersigned agrees to indemnify, hold harmless and defend the Elizabeth Stamped, the County of Elbert, the State of Colorado,
                  any suppliers, sponsors and each and every and all of their officers, directors, members, servants, employees, agents or affiliates,
                  of and from any and all loss, liability or damage arising out of, directly or indirectly, the participation of the undersigned or
                  his child or children in the {{ currentYear }} Elizabeth Stampede Mutton Bustin'.</p>

                <p>This release shall be binding upon the undersigned and the undersigned's spouse, legal representatives, child or children, heirs,
                  successors and assigns, and should any term or other provision of this release be held invalid, illegal or incapable of being
                  enforced due to any rule of law or public policy, all of the other conditions, provisions and paragraphs of this release shall
                  nevertheless remain in full force and effect. I agree to be bound in my individual capacity as a parent or legal guardian for the
                  child or children I enter into or allow to participate in the {{ currentYear }} Elizabeth Stampede Mutton Bustin'.</p>

                <p>The laws of the State of Colorado will apply in all instances regarding the interpretation and enforceability of this release and this
                  release shall be performed in the County of Elbert, State of Colorado.</p>

                <p>The undersigned has full power, authority, capacity and right without limitations to execute, deliver and perform this completed release.</p>

                <p>This release has been carefully and fully read by the undersigned and the undersigned fully understands its terms and conditions and
                  has voluntarily executed and delivered this release by choosing the checkbox below.</p>
            </div>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-checkbox
                v-model="checkbox"
                label="I have read and agree to the Complete Participants Release!"
                :rules="[v => !!v || 'You must agree to continue!']"
                required
              ></v-checkbox>
              <v-btn color="primary" @click="save">Submit Application</v-btn>
            </v-card-actions>
          </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      saved: false,
      editedItem: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        homePhone: '',
        cellPhone: '',
        email: '',
        age: '',
        weight: '',
        birthDate: '',
        other: '',
        parents: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
  },

  methods: {
    getDate () {
      this.currentYear = moment().format('YYYY')
      // let nextYear = moment()
      //   .add(1, 'years')
      //   .format('YYYY')
      // let currentDate = moment().format('MM')

      // if (currentDate >= 7) {
      //   this.currentYear = nextYear
      // } else {
      //   this.currentYear = currentYear
      // }
    },

    async save () {
      try {
        this.editedItem.year = moment()
          .format('YYYY')

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_busters', this.editedItem)
          console.log(response.data)

          this.saved = true
          this.snackbar.message = 'Congratulation, your child has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/muttonBustin/ExternalForm.vue